import $x from '@/utils/$x';

// 渠道列表
export async function getChannelList(params) {
  return $x.post('/contentChannel/getChannelCategoryRelPage', params);
}

// 查询一般专题列表
export async function getTopicList(params) {
  return $x.post('/topic/list', params);
}

// 删除专题
export async function deleteTopic(params) {
  return $x.post('/topic/deleteTopic', params);
}

// 查询栏目列表
export async function getTabList(params) {
  return $x.post('/tab/getTabList', params);
}

// 查询删除栏目
export async function deleteTabPage(params) {
  return $x.post('/tab/deleteTabPage', params);
}

// 查询保存栏目
export async function saveTabPage(params) {
  return $x.post('/tab/saveTabPage', params);
}

// 查询专题详情
export async function getTopicDetail(params) {
  return $x.post('/topic/detail', params);
}

// 新增专题
export async function addTopic(params) {
  return $x.post('/topic/addTopic', params);
}

// 编辑专题
export async function updateTopic(params) {
  return $x.post('/topic/updateTopic', params);
}

// 查询课程
export async function queryContentPage(params) {
  return $x.post('/content/queryContentPage', params);
}

// 查询栏目关联专题列表
export async function getTabPageTopicList(params) {
  return $x.post('/tab/getTabPageTopicList', params);
}

// 设置栏目与专题关联关系
export async function addTabPageTopicRel(params) {
  return $x.post('/tab/addTabPageTopicRel', params);
}

// 解除栏目与专题关联关系
export async function deleteTabPageTopicRel(params) {
  return $x.post('/tab/deleteTabPageTopicRel', params);
}

//  查询栏目推荐位课程列表
export async function getTabPageContentList(params) {
  return $x.post('/tab/getTabPageContentList', params);
}

//  栏目推荐位课程 关联关系
export async function saveTabPageContentRel(params) {
  return $x.post('/tab/saveTabPageContentRel', params);
}

//  解绑tab页和课程的关联关系
export async function deleteTabPageContentRel(params) {
  return $x.post('/tab/deleteTabPageContentRel', params);
}

//  设置栏目下专题排序权重
export async function setTopicOrderWithTab(params) {
  return $x.post('/tab/setTopicOrder', params);
}

/**
 * 营销配置字典
 */
export async function getMarketDict(params) {
  return $x.post('/market/getMarketDict', params);
}
//  查询营销位配置列表
export async function getMarketList(params) {
  return $x.post('/market/getMarketList', params);
}
//  新增营销位
export async function marketAdd(params) {
  return $x.post('/market/add', params);
}
//  上下架删除 营销位
export async function operateMarket(params) {
  return $x.post('/market/operate', params);
}

// 更新 营销位
export async function marketUpdate(params) {
  return $x.post('/market/update', params);
}

/**
 *  品类
 */

//  查询品类树
export async function getCategoryTree(params) {
  return $x.post('/category/getLittaCategoryTree', params);
}

//  根据id查品类详情
export async function getLittaCategoryById(params) {
  return $x.post('/category/getLittaCategoryById', params);
}

// 根据一级分类的id获取绑定渠道
export async function getChannelByCategoryId(params) {
  return $x.post('/contentChannel/getChannelByCategoryId', params);
}

/**
 * 视频管理
 */

export async function getVideoList(params) {
  return $x.post('/media/findMediaByPage', params);
}

// 编辑分类介绍
export async function editLittaCategoryIntro(params) {
  return $x.post('/category/editLittaCategoryIntro', params);
}

//  渠道删除
export async function deleteChannelById(params) {
  return $x.post('/contentChannel/deleteChannelCategoryRel', params);
}

//渠道列表
export async function getChannelCategoryList(params) {
  return $x.post('/contentChannel/getChannelCategoryRelPage', params);
}

//启动/禁用渠道
export async function enableOrDisableChannel(params) {
  return $x.post('/contentChannel/enableOrDisableChannelCategoryRel', params);
}

// 获取渠道字典项
export async function getChannelConfig(params) {
  return $x.post('/ConfigApi/getConfigDictionary', params);
}

//更新渠道
export async function updateLittaChannelCategory(params) {
  return $x.post('/contentChannel/updateLittaChannelCategoryRel', params);
}

//添加渠道
export async function addLittaChannelCategory(params) {
  return $x.post('/contentChannel/addLittaChannelCategoryRel', params);
}

//查询分类信息
export async function getLittaCategoryInfo(params) {
  return $x.post('/category/getLittaCategoryInfo', params);
}

//根据ID获取内容详情
export async function getLittaContentById(params) {
  return $x.post('/content/getLittaContentById', params);
}

//渠道ID字典
export async function getChannelIdList(params) {
  return $x.post('/contentChannel/getChannelDictionary', params);
}

//配置列表
export async function getIntroList(params) {
  return $x.post('/page/content/config/list', params);
}

//获取上架配置列表
export async function listContentIntro(params) {
  return $x.post('/page/content/config/listContent', params);
}

//查看配置
export async function viewIntro(params) {
  return $x.post('/page/content/config/view', params);
}

//配置新增或修改
export async function saveOrUpdateIntro(params) {
  return $x.post('/page/content/config/saveOrUpdate', params);
}

//配置上/下架
export async function onOrOffIntro(params) {
  return $x.post('/page/content/config/onOrOff', params);
}

//获取页面路由配置
export async function listContentRouteIntro(params) {
  return $x.post('/page/content/config/listContentRoute', params);
}
export async function listKnowledge(params) {
  return $x.post('/knowledge/base/list', params);
}
export async function addOrModifyKnowledge(params) {
  return $x.post('/knowledge/base/addOrModify', params);
}
export async function auditKnowledge(params) {
  return $x.post('/knowledge/base/audit', params);
}

export async function deleteKnowledge(params) {
  return $x.post('/knowledge/base/del', params);
}

export async function saveHotAudio(params) {
  return $x.post('/hotmaterial/save', params);
}
export async function delHotAudio(params) {
  return $x.post('/hotmaterial/del', params);
}
export async function lsitHotAudio(params) {
  return $x.post('/hotmaterial/list', params);
}
export async function listClass(params) {
  return $x.post('/hotmaterial/listClass', params);
}

// 搜索企业
export async function searchEnterprise(params) {
  return $x.post('/enterprise/searchEnterprise', params);
}
